import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Error404 from '../../Page/Error404';
import DashboardPage from '../../Page/DashboardPage';
import ManageVehiclePage from '../../Page/ManageVehiclePage';
import AddVehicle from '../../components/vehicle/AddVehicle';
import SpecialServices from '../../Page/SpecialServices';
import AddSS from '../../components/SpecialServices/AddSS';
import Services from '../../Page/Services';
import AddS from '../../components/Services/AddS';
import HomePageSeo from '../../Page/SEO/HomePageSeo';
import UploadPage from '../../Page/UploadPage';
import AboutPageSeo from '../../Page/SEO/AboutPageSeo';
import ServicePageSeo from '../../Page/SEO/ServicePageSeo';
import ContactusPageSeo from '../../Page/SEO/ContactusPageSeo';
import ProfilePageSeo from '../../Page/SEO/ProfilePageSeo';
import SelectcarSeo from '../../Page/SEO/SelectcarSeo';
import PageBuilder from '../../Page/PageBuilder';
import PageBuild from '../../components/PageBuilder/PageBuild';
import PageConfigSelect from '../../components/PageBuilder/build_page/PageConfigSelect';
import OfferPage from '../../Page/OfferPage';
import OrderPage from '../../Page/OrderPage';
import DriverPage from '../../Page/DriverPage';
import ConfigPage from '../../Page/ConfigPage';

const allRoutes = [
  { url: "", component: <DashboardPage /> },
  { url: "/dashboard", component: <DashboardPage /> },
  { url: "/manage-vehicle", component: <ManageVehiclePage /> },
  { url: "/add-vehicle", component: <AddVehicle /> },
  { url: "/edit-vehicle", component: <AddVehicle /> },
  { url: "/manage-sepcial-services", component: <SpecialServices /> },
  { url: "/create-special-services", component: <AddSS /> },
  { url: "/update-special-services", component: <AddSS /> },

  { url: "/manage-services", component: <Services /> },
  { url: "/manage-orders", component: <OrderPage /> },
  { url: "/create-services", component: <AddS /> },
  { url: "/update-services", component: <AddS /> },
  { url: "/manage-uploads", component: <UploadPage /> },
  { url: "/home-page-seo", component: <HomePageSeo /> },
  { url: "/about-page-seo", component: <AboutPageSeo /> },
  { url: "/contact-us-page-seo", component: <ContactusPageSeo /> },
  { url: "/service-page-seo", component: <ServicePageSeo /> },
  { url: "/profile-page-seo", component: <ProfilePageSeo /> },
  { url: "/select-car-page-seo", component: <SelectcarSeo /> },
  { url: "/page-builder", component: <PageBuilder /> },
  { url: "/page-builder/manage", component: <PageConfigSelect /> },
  { url: "/coupon-offers", component: <OfferPage /> },
  { url: "/manage-drivers", component: <DriverPage /> },
  { url: "/configuration", component: <ConfigPage /> },
  
];

const AppRoutes = () => {
  return (
    <Routes>
      {allRoutes.map((route, index) => (
        <Route
          key={index}
          path={route.url}
          element={route.component}
        />
      ))}

s      <Route
        path="/"
        element={<Navigate to="/dashboard" replace />}
      />
      {/* Handle 404 */}
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
};

export default AppRoutes;